<template>
    <div class="cardTypeVehicle" @click="saveNameVehicle" v-bind:class="{ selected: isSelected }">
        <div class="cardTypeVehicle__header">
            <div class="header__title">
                <img :src="srcIconVehicle" v-if="visibleIcon" alt="">
                <h2 class="typeVehicle">{{ typeVehicle }}</h2>
            </div>
            <div class="header__icon">
                <img src="../../../public/images/arrow-forward.svg" class="arrow-forward" v-if="visibleIconNextStep" @click="selectVehicle">
            </div>
        </div>
        <div class="cardTypeVehicle__description">
            <p class="descriptionTypeVehicle">{{ typeVehicleDescription }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            typeVehicle: {
                type: String,
                required: true
            },
            typeVehicleDescription: {
                type: String,
                required: true
            },
            srcIconVehicle: {
                type: String,
                required: false
            },
            visibleIcon: {
                type: Boolean,
                default: false
            },
            selectVehicle: {
                type: Function,
                required: false
            },
            saveNameVehicle: {
                type: Function,
                required: false
            },
            visibleIconNextStep: {
                type: Boolean,
                required: false,
                default: true
            },
            isSelected: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            selectVehicleComponent(){
                this.selectVehicle()
                this.saveNameVehicle()
            }
        }
    }
</script>
